require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./learning-family-participation-communication.json") })
        }
      }, "path---learning-family-participation-communication");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---learning-family-participation-communication!./.cache/json/learning-family-participation-communication.json
// module id = 1239
// module chunks = 231608221292675